<template>
  <div lang="tr" class="vertical-align-step-0">
    <form method="POST" id="step0" @submit.prevent="sendForm" class="mb-4">
      <h3 class="main_question text-center font-weight-normal mt-4 font-weight-bold">{{ $t('Ek Hizmetler') }}</h3>
      <hr />
      <div v-for="product in products" :key="product.id">
        <div
          @click="changeSelectedProducts(product.code, price.companyType.data)"
          v-for="price in product.prices.data"
          class="d-flex justify-content-between box-border gap-field"
          :key="price.id"
          v-bind:class="{ 'selected-product': selectedProducts.includes(product.code) }"
        >
          <div class="vertical-center ml-1">
            <div>
              <h6 class="mb-1 font-weight-bold">{{ getProductName(product) }}</h6>
              <h6>
                {{ formatPrice(Number(price.price), '￡') }} / {{ product.period === 'annual' ? $t('Yıl') : $t('Ay') }}
              </h6>
            </div>
            <div>
              <p class="mb-0">{{ getProductDescription(product) }}</p>
            </div>
          </div>

          <div class="text-center vertical-center product-image">
            <img src="/img/company-types/tax-filing.svg" class="company-type-default" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import RegisterStore from '../../../stores/register';
import CompanyStore from '../../../stores/company';
import ProductStore from '@/stores/product';

export default {
  data() {
    return {
      secondary: ['UKTAX', 'UKTAXMONTHLY'],
      products: [],
      selectedProducts: [],
      company: {
        global_activity_area: null,
      },
    };
  },
  created() {
    this.fillPage();
  },
  methods: {
    async fillPage() {
      this.startWaiting();
      CompanyStore.dispatch('getCompany').then((s) => {
        if (s.data.data.length) {
          this.company = s.data.data[0];
          this.$store.commit('setCompany', s.data.data[0]);

          this.getProducts();
        }
      });
    },

    getProducts() {
      ProductStore.dispatch('getProductsByAddionalProduct', {
        companyId: this.company.id,
      }).then((s) => {
        this.products = s.data.data;
        this.endWaiting();

        if (this.company.package) {
          const matchingCodes = this.products
            .filter((product) => this.company.package.includes(product.code))
            .map((product) => product.code);

          this.selectedProducts = matchingCodes;
        }
      });
    },
    changeSelectedProducts(code, companyType) {
      if (this.selectedProducts.includes(code)) {
        this.selectedProducts.splice(this.selectedProducts.indexOf(code), 1);
      } else {
        this.selectedProducts.push(code);
      }
    },
    async sendForm(callback) {
      let packageData = [];
      if (Array.isArray(this.company.package)) {
        packageData = [...this.company.package];
      }
      const removeArray = this.products.map((obj) => obj.code);

      packageData = packageData.filter((item) => !removeArray.includes(item));

      packageData = packageData.concat(this.selectedProducts);
      if (!packageData.length) {
        this.$toasted.error(this.$t('AlertMessages.Lütfen bir ürün seçin'));
        return;
      }
      this.startWaiting();

      RegisterStore.dispatch('package', {
        packages: packageData,
      }).then((s) => {
        callback();
      });
    },
  },
};
</script>
<style>
.selected-activity-items {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
}
.selected-activities {
  display: flex;
  align-items: center;
  border: 1px solid #dee2e6;
  padding: 10px 8px !important;
  gap: 10px;
  align-self: stretch !important;
}

.selected-activities .btn {
  padding: 0 !important;
}

.activity-area-warning {
  margin-top: 10px;
  color: black;
}

.activity-area-warning .fa-info-circle {
  margin-right: 8px;
}
</style>
